// import Vue from "vue";
import * as actionTypes from "../mutation-types";

// initial state
const state = {
	persistedData: {
		products: [],
		maximumNumber: null,
		crossSellDisplayedOnCatalogPages: {},
		crossSellProductForAddToCart: {}
	}
};

// getters
const getters = {
	upsellRulesProducts: state => state.persistedData.products,
	upsellRulesMaximumNumber: state => state.persistedData.maximumNumber,
	crossSellDisplayedOnCatalogPages: state => state.persistedData.crossSellDisplayedOnCatalogPages,
	crossSellProductForAddToCart: state => state.persistedData.crossSellProductForAddToCart
};

// actions
const actions = {
	[actionTypes.SET_UPSELL_RULES]: ({ commit }, data) => {
		return commit(actionTypes.SET_UPSELL_RULES, data);
	}
};

// mutations
const mutations = {
	[actionTypes.SET_UPSELL_RULES] (state, payload) {
		state.persistedData.products = payload.upsellRules.products;
		state.persistedData.maximumNumber = payload.upsellRules.maximumNumber;
	},
	[actionTypes.SET_CROSS_SELL_DISPLAYED_ON_CATALOG_PAGE]: (state, data) => {
		state.persistedData.crossSellDisplayedOnCatalogPages = {
			...(state.persistedData.crossSellDisplayedOnCatalogPages || {}),
			...data
		};
	},
	[actionTypes.CLEAR_ALL_CROSS_SELL_DISPLAYED_ON_CATALOG_PAGE]: (state) => {
		state.persistedData.crossSellDisplayedOnCatalogPages = {};
		state.persistedData.crossSellProductForAddToCart = null;
	},
	[actionTypes.CROSS_SELL_PRODUCT_FOR_ADD_TO_CART]: (state, data) => {
		state.persistedData.crossSellProductForAddToCart = data;
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};
